import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { api } from '../services/api';

export interface GlobalMarqueeConfig {
  enabled: boolean;
  text: string | null;
}

export interface UseGlobalMarqueeReturn extends GlobalMarqueeConfig {
  loading: boolean;
  error: Error | null;
  refetch: () => Promise<unknown>;
}

export function useGlobalMarquee(): UseGlobalMarqueeReturn {
  const { token, isAuthenticated } = useAuth();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['global-marquee', token],
    queryFn: async (): Promise<GlobalMarqueeConfig> => {
      if (!token) {
        return { enabled: false, text: null };
      }
      const response = await api.get('/user/app-settings/global-marquee', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const body = response.data ?? {};
      return {
        enabled: body.enabled === true,
        text: body.text ?? null,
      };
    },
    enabled: isAuthenticated && !!token,
    staleTime: 2 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: true,
    retry: 1,
  });

  return {
    enabled: data?.enabled ?? false,
    text: data?.text ?? null,
    loading: isLoading,
    error: error as Error | null,
    refetch,
  };
}
